// @ts-check

import { BubbleLoader } from './BubbleLoader/BubbleLoader';
import { SpinnerLoader } from './SpinnerLoader/SpinnerLoader';
// default  loader
const Loader = BubbleLoader;

export { Loader, BubbleLoader, SpinnerLoader };
